import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { canMockFeatureFlags, getLocalFeatureFlags } from '@app/functions/feature-flags.helpers';
import { Observable } from 'rxjs';
import { shouldSkipInterceptor } from './helpers/shouldSkipInterceptor';

/**
 * This Interceptor is conditionally added to some environments via the FeatureFlagInterceptor.module.
 * This ensures that we never load it into Production, thus reducing the steps network requests need to take.
 * This interceptor simply adds flag values as query params to all requests through Angular's HttpClient
 */
@Injectable()
export class FeatureFlagInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Skip interception for disallowed URLs or if we are not mocking flags
        if (shouldSkipInterceptor(req.url) || !canMockFeatureFlags()) {
            return next.handle(req);
        }

        const featureFlags = getLocalFeatureFlags();

        // Add to the existing params from the request
        let featureFlagParams = req.params;

        // Append enabled feature flags to the url query string
        Object.entries(featureFlags).forEach(
            ([key, value]) => (featureFlagParams = featureFlagParams.append(`featureFlags[${key}]`, value))
        );

        return next.handle(req.clone({ params: featureFlagParams }));
    }
}
